export const ErrorIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <circle cx="12" cy="12" r="12" fill="#CE5342" />
            <path
                d="M15.8239 8.17605C15.4506 7.80268 14.8452 7.80268 14.4718 8.17605L12 10.6479L9.52816 8.17605C9.15478 7.80268 8.54943 7.80268 8.17605 8.17605C7.80268 8.54942 7.80268 9.15478 8.17605 9.52816L10.6479 12L8.17605 14.4718C7.80268 14.8452 7.80268 15.4506 8.17605 15.8239C8.54942 16.1973 9.15478 16.1973 9.52816 15.8239L12 13.3521L14.4718 15.8239C14.8452 16.1973 15.4506 16.1973 15.8239 15.8239C16.1973 15.4506 16.1973 14.8452 15.8239 14.4718L13.3521 12L15.8239 9.52815C16.1973 9.15478 16.1973 8.54942 15.8239 8.17605Z"
                fill="white"
            />
        </svg>
    );
};
